import Header from './components/Header';
import Hero from './components/Hero';
import { UpdatesSection, CarouselSection, AboutSection, ContactSection, FeaturesSection, AppSection } from './components/SectionsPart1';
import { CardsSection, MediaSection, FaqSection } from './components/SectionsPart2';
import { RankingSection, IndexSection, TopicsSection, CommentsSection } from './components/SectionsPart3';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CarouselSection />
        <AboutSection />
        <ContactSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
        <MediaSection />
        <FaqSection />
        <RankingSection />
        <IndexSection />
        <TopicsSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}